const FORM_DESIGN_ITEM = "FORM_DESIGN_ITEM";
const DATA_DESIGN_ITEM = "DATA_DESIGN_ITEM";
const FORM_PROPERTYv2 = "FORM_PROPERTY_ITEM";
const DATA_PROPERTYv2 = "DATA_PROPERTY_ITEM";
const FORM_ADDv2 = "FORM_ADD_ITEM";
const DATA_ADDv2 = "DATA_ADD_ITEM";
const FORM_CANCELv2 = "FORM_CANCEL_ITEM";
const FORM_CANCEL_RETURNv2 = "FORM_CANCEL_R_ITEM";
const DATA_CANCELv2 = "DATA_CANCEL_ITEM";
const LAUNCHSEARCHv2 = "FORM_EXECUTESEARCH_ITEM";
const RESETSEARCHCRITERIAv2 = "FORM_RESETSEARCHCRITERIA_ITEM";
const FORM_ARCHIVE_MODEv2 = "FORM_ENABLEARCHIVE_ITEM";
const DATA_ARCHIVE_MODEv2 = "DATA_ENABLEARCHIVE_ITEM";
const FORM_NORMAL_MODEv2 = "FORM_DISABLEARCHIVE_ITEM";
const DATA_NORMAL_MODEv2 = "DATA_DISABLEARCHIVE_ITEM";
const FORM_VALIDATEv2 = "FORM_VALIDATE_ITEM";
const FORM_VALIDATE_RETURNv2 = "FORM_VALIDATE_R_ITEM";
const DATA_VALIDATEv2 = "DATA_VALIDATE_ITEM";
const SEARCHv2 = "FORM_SEARCH_ITEM";
const DUPLICATEv2 = "FORM_DUPLICATE_ITEM";
const FORM_RESTOREv2 = "FORM_RESTORE_ITEM";
const DATA_RESTOREv2 = "DATA_RESTORE_ITEM";
const FORM_ARCHIVE_ONv2 = "FORM_ARCHIVE_ITEM";
const DATA_ARCHIVE_ONv2 = "DATA_ARCHIVE_ITEM";
const FORM_DELETEv2 = "FORM_DELETE_ITEM";
const DATA_DELETEv2 = "DATA_DELETE_ITEM";
const WORDv2 = "FORM_WORDEXPORT_ITEM";
const DATA_WORDv2 = "DATA_WORDEXPORT_ITEM";
const FORM_EXCELv2 = "FORM_EXCELEXPORT_ITEM";
const DATA_EXCELv2 = "DATA_EXCELEXPORT_ITEM";
const FORM_RSSv2 = "FORM_RSSEXPORT_ITEM";
const DATA_RSSv2 = "DATA_RSSEXPORT_ITEM";
const FORM_REFRESH = "FORM_REFRESH_ITEM";
const DATA_REFRESH = "DATA_REFRESH_ITEM";
const DATA_CLOSE = "DATA_CLOSE_ITEM";
const FILLREPLACEv2 = "DATA_FILLREPLACE_ITEM";
const OPEN_SIGNATUREv2 = "FORM_SIGNATURES_LIST";
const DEL_REQUESTv2 = "DATA_DELETEREQUEST_ITEM";
const NEWCONFIG_REQUESTv2 = "DATA_NEWSETUPREQUEST_ITEM";
const PROPERTYREQUESTv2 = "PROPERTYREQUEST_ITEM";
const NOTE_ITEM = "FORM_NOTE_ITEM";
const UPDATES_LIST = "FORM_UPDATES_LIST";
const ACTIVATE_FOR_PURGE = "actionAssocReqPurge";
const LIER_COMME_PERE = "actionLierCommePere";
const DESACTIVATE_FOR_PURGE = "actionDissocReqPurge";
const CANCELRETURNv2 = "DATA_CANCELRETURN_ITEM";
const DATA_HIERARCHICMODE_ITEM = "DATA_HIERARCHICMODE_ITEM";
const DATA_CLASSICMODE_ITEM = "DATA_CLASSICMODE_ITEM";
const ASSOCIATEv2 = "DATA_ASSOCIATE_ITEM";
const DISSOCIATEv2 = "DATA_DISSOCIATE_ITEM";
const EXPANDv2 = "DATA_EXPAND_ITEM";
const COLLAPSEv2 = "DATA_COLLAPSE_ITEM";
const DATA_SELECTALL = "DATA_SELECTALL_ITEM";
const actionReinitMenu = "actionReinitMenu";
const FORM_ASSOCIATEDVIEW_GROUP = "FORM_ASSOCIATEDVIEW_GROUP";
const ACTION_DEMANDE_ANNULATION = "actionDemandeAnnulation";
const FORM_SELECT = "FORM_SELECT_ITEM";

// CLEM 101715 - MenuGroup du menu principal
const mnuPrinc = "mnuPrinc";

//RGEL - DEV 43751 -  Ajout des action Marquer/Demarquer sur un formulaire
const MARK_ITEM = "FORM_MARK_ITEM";
const UNMARK_ITEM = "FORM_UNMARK_ITEM";
//CCAP - 145173 - Marquer démarquer sur une grille
const DATA_MARK_ITEM = "DATA_MARK_ITEM";
const DATA_UNMARK_ITEM = "DATA_UNMARK_ITEM";

// *****************************************************************************
// Actions effectuees sur le menu des modules
const QUIT = "QUIT";
const HELP = "HELP";
const HOME = "HOME";
const HOMEICONE = "HOMEICONE";
const APROPOS = "APROPOS";
//CLEM - 134179 - Lignes de commandes pour les raccourcis en mutliNav-PB0016741
const IWSPROTOCOL = "IWSPROTOCOL";
const INFORMATION = "INFORMATION";
const PASSWORD = "PASSWORD";
const CONTACT = "CONTACT";
const WEBSITE = "WEBSITE";
const GENFASTMAIL = "GENFASTMAIL";
const MENTIONSLEGALES = "MENTIONSLEGALES";

// changement de profil
const MNUP_CHG_PROFIL = "mnuChgProfil";
// group de l'item clique du bouton Iws
const MNUP_BTN_IWS_CLICK_GR = "mnuIws";
// group de l'item clique des bouton icones
const MNU_ICONE_CLICK_GR = "mnuIcones";
// Id du control stockant la valeur clique des menus icones
const IHD_ICONE_CLICK_ITEM_ID = "ihdItemClickmnuIcones";
// Id du control stockant la valeur clique des menus iws
const IHD_IWS_CLICK_ITEM_ID = "ihdItemClickmnuIws";
// Id du control stockant la valeur clique des menus module
const IHD_MM_CLICK_ITEM_ID = "ihdCurrentItemmnuModule";

const ModuleAdmin = "WA"; //Module Administration
const ModuleInvent = "WI"; //Module Inventaire
const ModuleAssetManag = "WP"; //Module IsiParc
const ModuleHelpDesk = "WH"; //Module HelpDesk
const ModuleCommon = "WC"; //Module commun pour IsiParc et HelpDesk
const ModuleAudit = "WT"; //Module audit

const HEIGHTDOCKEDBAR = 36;
const BUTTONBARDETAIL = "IsiButtonBarDetail";
const BUTTONBARFORM = "IsiButtonBarForm";
const SCROLLVIEWID = "bsv"
const BUTTONBARFORMSCROLLVIEW = BUTTONBARFORM + SEP_ENCAPS_CTRL + SCROLLVIEWID;
const IWS_SESSION_ID_URL_PARAM = "IwsId=";
const diagSessionId = "diagSessionId="; 
// DtoClient ouverture onglet
const IWS_ORIGIN_SESSION_ID_URL_PARAM = "OriginIwsId=";

const WAITTIMEOUT = 4000;

const NAME_B_SELECTED_COL = "B_SELECTED";
const NAME_EXTENSION_FORMAT = "_FORMAT";
const SEP_COL = ";";
const SEP_ACTION = ",";
const SEP_VALUE_GRID = "=";
const SEP_COLUMN_GRID = "#";

// definition des états possibles du curseur
const SEARCH = "StateSearch";
const CONSULT = "StateConsult";
const AJOUT = "StateAdd";
const DUPLICATE = "StateDuplicate";
const MODIFICATION = "StateUpdate";
const UNKNOW = "StateNone";
const ARCHIVE = "Archive_Mode";
const DEFAULT = "Default_Mode";
const LOCK = "StateLock";

// Constantes permettant de connaitre le type d'action souhaitee lors de l'appel
// a la fonction IsiAsyncCtrlConnexe
const GET_VALUE = "GETVALUE";
const GET_TEXT = "GETTEXT";

/**********************************************************/
//Replace const ([a-zA-Z0-9_]*) = .*; avec window.$1 = $1;
window.FORM_DESIGN_ITEM = FORM_DESIGN_ITEM;
window.DATA_DESIGN_ITEM = DATA_DESIGN_ITEM;
window.FORM_SELECT = FORM_SELECT;
window.FORM_PROPERTYv2 = FORM_PROPERTYv2;
window.DATA_PROPERTYv2 = DATA_PROPERTYv2;
window.FORM_ADDv2 = FORM_ADDv2;
window.DATA_ADDv2 = DATA_ADDv2;
window.FORM_CANCELv2 = FORM_CANCELv2;
window.FORM_CANCEL_RETURNv2 = FORM_CANCEL_RETURNv2;
window.DATA_CANCELv2 = DATA_CANCELv2;
window.LAUNCHSEARCHv2 = LAUNCHSEARCHv2;
window.RESETSEARCHCRITERIAv2 = RESETSEARCHCRITERIAv2;
window.FORM_ARCHIVE_MODEv2 = FORM_ARCHIVE_MODEv2;
window.DATA_ARCHIVE_MODEv2 = DATA_ARCHIVE_MODEv2;
window.FORM_NORMAL_MODEv2 = FORM_NORMAL_MODEv2;
window.DATA_NORMAL_MODEv2 = DATA_NORMAL_MODEv2;
window.FORM_VALIDATEv2 = FORM_VALIDATEv2;
window.FORM_VALIDATE_RETURNv2 = FORM_VALIDATE_RETURNv2;
window.DATA_VALIDATEv2 = DATA_VALIDATEv2;
window.SEARCHv2 = SEARCHv2;
window.DUPLICATEv2 = DUPLICATEv2;
window.FORM_RESTOREv2 = FORM_RESTOREv2;
window.DATA_RESTOREv2 = DATA_RESTOREv2;
window.FORM_ARCHIVE_ONv2 = FORM_ARCHIVE_ONv2;
window.DATA_ARCHIVE_ONv2 = DATA_ARCHIVE_ONv2;
window.FORM_DELETEv2 = FORM_DELETEv2;
window.DATA_DELETEv2 = DATA_DELETEv2;
window.WORDv2 = WORDv2;
window.DATA_WORDv2 = DATA_WORDv2;
window.FORM_EXCELv2 = FORM_EXCELv2;
window.DATA_EXCELv2 = DATA_EXCELv2;
window.FORM_RSSv2 = FORM_RSSv2;
window.DATA_RSSv2 = DATA_RSSv2;
window.FORM_REFRESH = FORM_REFRESH;
window.DATA_REFRESH = DATA_REFRESH;
window.DATA_CLOSE = DATA_CLOSE;
window.FILLREPLACEv2 = FILLREPLACEv2;
window.OPEN_SIGNATUREv2 = OPEN_SIGNATUREv2;
window.DEL_REQUESTv2 = DEL_REQUESTv2;
window.NEWCONFIG_REQUESTv2 = NEWCONFIG_REQUESTv2;
window.PROPERTYREQUESTv2 = PROPERTYREQUESTv2;
window.NOTE_ITEM = NOTE_ITEM;
window.UPDATES_LIST = UPDATES_LIST;
window.DESACTIVATE_FOR_PURGE = DESACTIVATE_FOR_PURGE;
window.LIER_COMME_PERE = LIER_COMME_PERE;
window.ACTIVATE_FOR_PURGE = ACTIVATE_FOR_PURGE;

window.CANCELRETURNv2 = CANCELRETURNv2;
window.DATA_HIERARCHICMODE_ITEM = DATA_HIERARCHICMODE_ITEM;
window.DATA_CLASSICMODE_ITEM = DATA_CLASSICMODE_ITEM;
window.ASSOCIATEv2 = ASSOCIATEv2;
window.DISSOCIATEv2 = DISSOCIATEv2;
window.EXPANDv2 = EXPANDv2;
window.COLLAPSEv2 = COLLAPSEv2;
window.DATA_SELECTALL = DATA_SELECTALL;
window.FORM_ASSOCIATEDVIEW_GROUP = FORM_ASSOCIATEDVIEW_GROUP;
window.ACTION_DEMANDE_ANNULATION = ACTION_DEMANDE_ANNULATION;

// CLEM 101715 - MenuGroup du menu principal
window.mnuPrinc = mnuPrinc;

//RGEL - DEV 43751 -  Ajout des action Marquer/Demarquer sur un formulaire
window.MARK_ITEM = MARK_ITEM;
window.UNMARK_ITEM = UNMARK_ITEM;
//CCAP - 145173 - Marquer démarquer sur une grille
window.DATA_MARK_ITEM = DATA_MARK_ITEM;
window.DATA_UNMARK_ITEM = DATA_UNMARK_ITEM;

// *****************************************************************************
// Actions effectuees sur le menu des modules
window.QUIT = QUIT;
window.HELP = HELP;
window.HOME = HOME;
window.HOMEICONE = HOMEICONE;
window.APROPOS = APROPOS;
//CLEM - 134179 - Lignes de commandes pour les raccourcis en mutliNav-PB0016741
window.IWSPROTOCOL = IWSPROTOCOL;
window.INFORMATION = INFORMATION;
window.PASSWORD = PASSWORD;

window.CONTACT = CONTACT;
window.WEBSITE = WEBSITE;
window.GENFASTMAIL = GENFASTMAIL;
window.MENTIONSLEGALES = MENTIONSLEGALES;

// changement de profil
window.MNUP_CHG_PROFIL = MNUP_CHG_PROFIL;
// group de l'item clique du bouton Iws
window.MNUP_BTN_IWS_CLICK_GR = MNUP_BTN_IWS_CLICK_GR;
// group de l'item clique des bouton icones
window.MNU_ICONE_CLICK_GR = MNU_ICONE_CLICK_GR;
// Id du control stockant la valeur clique des menus icones
window.IHD_ICONE_CLICK_ITEM_ID = IHD_ICONE_CLICK_ITEM_ID;
// Id du control stockant la valeur clique des menus iws
window.IHD_IWS_CLICK_ITEM_ID = IHD_IWS_CLICK_ITEM_ID;
// Id du control stockant la valeur clique des menus module
window.IHD_MM_CLICK_ITEM_ID = IHD_MM_CLICK_ITEM_ID;

window.ModuleAdmin = ModuleAdmin; //Module Administration
window.ModuleInvent = ModuleInvent; //Module Inventaire
window.ModuleAssetManag = ModuleAssetManag; //Module IsiParc
window.ModuleHelpDesk = ModuleHelpDesk; //Module HelpDesk
window.ModuleCommon = ModuleCommon; //Module commun pour IsiParc et HelpDesk
window.ModuleAudit = ModuleAudit; //Module audit

window.HEIGHTDOCKEDBAR = HEIGHTDOCKEDBAR;
window.BUTTONBARDETAIL = BUTTONBARDETAIL;
window.BUTTONBARFORM = BUTTONBARFORM;
window.BUTTONBARFORMSCROLLVIEW = BUTTONBARFORMSCROLLVIEW;
window.SCROLLVIEWID = SCROLLVIEWID;


window.IWS_SESSION_ID_URL_PARAM = IWS_SESSION_ID_URL_PARAM;
window.diagSessionId = diagSessionId;
// DtoClient ouverture onglet
window.IWS_ORIGIN_SESSION_ID_URL_PARAM = IWS_ORIGIN_SESSION_ID_URL_PARAM;

window.WAITTIMEOUT = WAITTIMEOUT;

window.NAME_B_SELECTED_COL = NAME_B_SELECTED_COL;
window.NAME_EXTENSION_FORMAT = NAME_EXTENSION_FORMAT;
window.SEP_COL = SEP_COL;
window.SEP_ACTION = SEP_ACTION;
window.SEP_VALUE_GRID = SEP_VALUE_GRID;
window.SEP_COLUMN_GRID = SEP_COLUMN_GRID;

// definition des états possibles du curseur
window.SEARCH = SEARCH;
window.CONSULT = CONSULT;
window.AJOUT = AJOUT;
window.DUPLICATE = DUPLICATE;
window.MODIFICATION = MODIFICATION;
window.UNKNOW = UNKNOW;
window.ARCHIVE = ARCHIVE;
window.DEFAULT = DEFAULT;
window.LOCK = LOCK;

window.GET_VALUE = GET_VALUE;
window.GET_TEXT = GET_TEXT;